var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.292 5.98C.923 7.314.923 9.156.923 12c0 4.038 0 6.057 1.058 7.473.341.457.755.859 1.225 1.19 1.456 1.03 3.533 1.03 7.686 1.03h2.216c4.153 0 6.23 0 7.686-1.03.47-.331.884-.733 1.225-1.19 1.058-1.416 1.058-3.435 1.058-7.473 0-2.852 0-4.697-.373-6.034l-2.33 2.265c-1.807 1.757-3.224 3.135-4.478 4.065-1.284.953-2.494 1.512-3.896 1.512s-2.612-.56-3.896-1.512c-1.254-.93-2.671-2.308-4.48-4.065L1.46 6.125z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.03 4.462.121.097.451.393 2.153 2.093c1.862 1.81 3.202 3.11 4.357 3.967 1.136.843 1.995 1.18 2.888 1.18s1.752-.337 2.888-1.18c1.155-.857 2.494-2.156 4.357-3.967l2.556-2.486.14-.134c-.342-.457-.677-.757-1.147-1.089-1.456-1.028-3.533-1.028-7.686-1.028h-2.216c-4.153 0-6.23 0-7.686 1.028a5 5 0 0 0-1.175 1.126"
  })));
};
export { SvgEnvelope as ReactComponent };